import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/correct_part_1_left.png'
import _imports_1 from '../../assets/images/correct_part_1_right.png'
import _imports_2 from '../../assets/images/correct_part_2_left.png'
import _imports_3 from '../../assets/images/correct_part_2_right.png'
import _imports_4 from '../../assets/images/correct_part_3_left.png'
import _imports_5 from '../../assets/images/correct_part_3_right.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2f568700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "correct-container" }
const _hoisted_2 = { class: "correct-title" }
const _hoisted_3 = { class: "correct-group" }
const _hoisted_4 = {
  key: 0,
  class: "correct-part-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct-part-1-title" }, "1、仅支持「学而思智能教辅」系列图书", -1))
const _hoisted_6 = {
  key: 1,
  class: "correct-part-usual"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct-part-usual-title" }, "1、完成作答后拍摄", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct-part-usual-box" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"correct-part-usual\" data-v-2f568700><div class=\"correct-part-usual-title\" data-v-2f568700>2、平行页面，整页竖屏拍摄</div><div class=\"correct-part-usual-box\" data-v-2f568700><img src=\"" + _imports_2 + "\" data-v-2f568700><img src=\"" + _imports_3 + "\" data-v-2f568700></div></div><div class=\"correct-part-usual\" data-v-2f568700><div class=\"correct-part-usual-title\" data-v-2f568700>3、保证图片清晰，不模糊</div><div class=\"correct-part-usual-box\" data-v-2f568700><img src=\"" + _imports_4 + "\" data-v-2f568700><img src=\"" + _imports_5 + "\" data-v-2f568700></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.title), 1),
    _createElementVNode("div", _hoisted_3, [
      ($setup.flag == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: "correct-part-1-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doJumpFn && $setup.doJumpFn(...args)))
            }, "查看支持图书")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)),
      _hoisted_10
    ])
  ]))
}